import React from 'react';

export default ({ isRequired = false, children }) => (
    <span>
        {children}
        {isRequired && <span style={{ marginLeft: '0.2em', color: '#a94442' }}>*</span>}
    </span>
);
